module.exports = __webpack_public_path__ + "static/usa-ad19b611b2da8b333a9c1af18261be56.jpg";